<app-navbar [title]="pageTitle">
	<button mat-raised-button color="primary" class="me-3" *ngIf="editable" (click)="submitAndExit()">
		Zapisz i wyjdź
	</button>
	<button mat-raised-button color="accent" class="me-3" *ngIf="editable" (click)="submitAndStay()">
		Zapisz i zostań
	</button>
	<button mat-raised-button color="primary" class="me-3" *ngIf="!editable" (click)="editUnlock()">Edycja</button>
	<a mat-raised-button color="warn" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="container my-4">
	<ul class="nav nav-tabs" id="myTab" role="tablist">
		<li class="nav-item">
			<a
				class="nav-link active"
				id="podstawowe-tab"
				data-bs-toggle="tab"
				href="#primaryData"
				role="tab"
				aria-controls="podstawowe"
				aria-selected="false"
				>Dane podstawowe</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="descriptions-tab"
				data-bs-toggle="tab"
				href="#descriptions"
				role="tab"
				aria-controls="descriptions"
				aria-selected="false"
				>Opisy</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="multimedia-tab"
				data-bs-toggle="tab"
				href="#multimedia"
				role="tab"
				aria-controls="multimedia"
				aria-selected="false"
				>Multimedia</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="optionalTrips-tab"
				data-bs-toggle="tab"
				href="#optionalTrips"
				role="tab"
				aria-controls="optionalTrips"
				aria-selected="false"
				>Wycieczki fakultatywne</a
			>
		</li>
	</ul>
	<div class="my-4">
		<div class="tab-content col" id="myTabContent">
			<div class="tab-pane fade active show" id="primaryData" role="tabpanel" aria-labelledby="podstawowe-tab">
				<app-location-basic [(data)]="data" [(locations)]="locations" [editable]="editable">
				</app-location-basic>
			</div>
			<div class="tab-pane fade" id="descriptions" role="tabpanel" aria-labelledby="descriptions">
				<app-location-descriptions [(data)]="data" [editable]="editable"> </app-location-descriptions>
			</div>
			<div class="tab-pane fade" id="multimedia" role="tabpanel" aria-labelledby="multimedia">
				<app-location-multimedias [(data)]="data" [editable]="editable"> </app-location-multimedias>
			</div>
			<div class="tab-pane fade" id="optionalTrips" role="tabpanel" aria-labelledby="optionalTrips">
				<app-location-optional-trip-list [(data)]="data" [editable]="editable">
				</app-location-optional-trip-list>
			</div>
		</div>
	</div>
</div>
